import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/api/capworks/",
  credentials: "include",
});

/**
 * Wrapper that surfaces `extraOptions` (e.g. { suppressNotification: true })
 * inside the response meta so the global requestErrorMiddleware can read them
 * via `action.meta.baseQueryMeta`.
 */
const baseQueryWithMeta = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  return { ...result, meta: { ...result.meta, ...extraOptions } };
};

export const capworksSignupService = createApi({
  reducerPath: "capworksSignupService",
  baseQuery: baseQueryWithMeta,
  endpoints: () => ({}),
});

